import React from 'react';

export function LoadingIcon() {
    return (
        <svg className="loader icon" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle fill="none" strokeLinecap="round" cx="33" cy="33" r="30" />
        </svg>
    );
}

export default function Loader({ id, className }) {
    return (
        <div className={`loader ${className || ''}`} id={id}>
            <LoadingIcon />
        </div>
    );
}
